import { handleActions } from 'redux-actions';
import update from 'react-addons-update';
import * as constants from '../constants/index';

const prepareData = (data) => ({
  ...data,
  // We need it because have different API and UI (hide_phone_number and show_phone_number)
  show_phone_number: !data.hide_phone_number,

  // We will reset SOFT user phone numbers, becuase have a conflict with old DB
  phone_1: data.type === 'SOFT' ? null : data.phone_1,
  phone_2: data.type === 'SOFT' ? null : data.phone_2,

  // Default business_type to show in dropdown menu
  business_type: data.business_type || 'BUSINESS',
  isCompany: data.type_of_person === 'LEGAL',
});

const initialState = {
  isLoading: true,
  data: {},
  errors: {},
  success: {},
  updateState: 0, //  0 - initial, 1 - updating,  2 - update success , 3 - update failure,
  uploadedKyc: [],
  uploading: false,
  isBankLoading: false,
  events: {},
  isLoadingEvents: false,
  todos: null,
  sessionStatus: null,
};

const resetUserState = (state) => update(state, {
  $set: initialState,
});

const setUserRequest = (state) => update(state, {
  isLoading: { $set: true },
  data: { $set: {} },
});

const setUserSuccess = (state, action) => update(state, {
  isLoading: { $set: false },
  data: { $set: prepareData(action.payload) },
});

const setUserFailure = (state, action) => update(state, {
  isLoading: { $set: false },
  data: { $set: {} },
  errors: { $set: action.payload.errors },
});

const setUserIdle = (state) => update(state, {
  errors: { $set: {} },
});

const postCreateUserSuccess = (state, action) => update(state, {
  data: { $set: prepareData(action.payload.results) },
});

const setUserSettingsSuccess = (state, action) => update(state, {
  data: { $set: prepareData(action.payload.user) },
});

const setUserUpdateRequest = (state) => update(state, {
  updateState: { $set: 1 },
});

const setUserUpdateSuccess = (state, action) => update(state, {
  updateState: { $set: 2 },
  success: { $set: { code: 'informationSaved' } },
  errors: { $set: {} },
  data: { $merge: prepareData(action.payload) },
});

const setUserUpdateFailure = (state, action) => update(state, {
  updateState: { $set: 3 },
  errors: { $set: action.payload.error },
});

const setUserUpdateIdle = (state) => update(state, {
  success: { $set: {} },
  errors: { $set: {} },
  updateState: { $set: 0 },
});

const resetUserForm = (state) => update(state, {
  updateState: { $set: 0 },
  errors: { $set: {} },
});

const fetchUploadedKYCRequest = (state) => update(state, {
  isLoading: { $set: true },
});

const fetchUploadedKYCSuccess = (state, action) => update(state, {
  isLoading: { $set: false },
  errors: { $set: {} },
  uploadedKyc: { $set: action.payload },
});

const fetchUploadedKYCFailure = (state, action) => update(state, {
  isLoading: { $set: false },
  errors: { $set: action.payload.error },
});

const uploadIDProofRequest = (state) => update(state, {
  uploading: { $set: true },
});

const uploadIDProofSuccess = (state, action) => update(state, {
  uploading: { $set: false },
  errors: { $set: {} },
  success: { $set: { code: 'successfulIdVerifying' } },
  uploadedKyc: { $push: [action.payload] },
  updateState: { $set: 2 },
  data: {
    $set: {
      ...state.data,
      kyc_status: 'PENDING',
    },
  },
});

const uploadIDProofFailure = (state, action) => update(state, {
  uploading: { $set: false },
  errors: { $set: action.payload.error },
});

const uploadIDProofIdle = (state) => update(state, {
  success: { $set: {} },
  errors: { $set: {} },
});

const deleteUserRequest = (state) => update(state, {
  errors: { $set: {} },
  isLoading: { $set: true },
});

const deleteUserFailure = (state, action) => update(state, {
  errors: { $set: action.payload.error },
  isLoading: { $set: false },
});

const setEvents = (state, action) => update(state, {
  events: { $set: action.payload },
  isLoadingEvents: { $set: false },
});

const setEventsLoading = (state) => update(state, {
  isLoadingEvents: { $set: true },
});

const setTodos = (state, action) => update(state, {
  todos: { $set: action.payload },
});

const patchTodosReadNews = (state, action) => update(state, {
  todos: {
    $set: (state.todos || []).filter((todo) => {
      if (todo.type !== 'UNREAD_NEWS') {
        return true;
      }

      return todo.value.id !== action.payload;
    }),
  },
});

const setSessionStatus = (state, action) => update(state, {
  sessionStatus: { $set: action.payload },
});

export default handleActions({
  [constants.RESET_USER_STATE]: resetUserState,

  [constants.FETCH_USER_SELF_REQUEST]: setUserRequest,
  [constants.FETCH_USER_SELF_IDLE]: setUserIdle,
  [constants.FETCH_USER_SELF_SUCCSSS]: setUserSuccess,
  [constants.FETCH_USER_SELF_FAILURE]: setUserFailure,

  [constants.UPDATE_USER_SETTINGS_SUCCESS]: setUserSettingsSuccess,

  [constants.UPDATE_USER_REQUEST]: setUserUpdateRequest,
  [constants.UPDATE_USER_SUCCESS]: setUserUpdateSuccess,
  [constants.UPDATE_USER_FAILURE]: setUserUpdateFailure,
  [constants.UPDATE_USER_IDLE]: setUserUpdateIdle,
  [constants.RESET_USER_FORM]: resetUserForm,

  [constants.POST_CREATE_USER_SUCCESS]: postCreateUserSuccess,

  [constants.FETCH_UPLOADED_KYC_REQUEST]: fetchUploadedKYCRequest,
  [constants.FETCH_UPLOADED_KYC_SUCCESS]: fetchUploadedKYCSuccess,
  [constants.FETCH_UPLOADED_KYC_FAILURE]: fetchUploadedKYCFailure,

  [constants.UPLOAD_IDPROOF_REQUEST]: uploadIDProofRequest,
  [constants.UPLOAD_IDPROOF_SUCCESS]: uploadIDProofSuccess,
  [constants.UPLOAD_IDPROOF_FAILURE]: uploadIDProofFailure,
  [constants.UPLOAD_IDPROOF_IDLE]: uploadIDProofIdle,

  [constants.DELETE_USER_REQUEST]: deleteUserRequest,
  [constants.DELETE_USER_IDLE]: uploadIDProofIdle,
  [constants.DELETE_USER_FAILURE]: deleteUserFailure,

  [constants.FETCH_SELF_EVENTS_REQUEST]: setEventsLoading,
  [constants.FETCH_SELF_EVENTS_SUCCESS]: setEvents,
  [constants.FETCH_TODOS_SUCCESS]: setTodos,
  [constants.PATCH_TODOS_READ_NEWS]: patchTodosReadNews,

  [constants.FETCH_SESSION_STATUS_SUCCESS]: setSessionStatus,

}, initialState);
